/* Ambient cigar haze across the hero, disturbed by the pointer.
   Each puff springs back toward a slowly drifting "home", with a perpendicular
   curl term so it swirls back rather than snapping. Overdamped, so it eases
   home without bouncing. Particles are drawn from one pre-rendered sprite.
   Pauses off-screen; off by default under prefers-reduced-motion. */
(function () {
  'use strict';

  var host = document.querySelector('[data-smoke]');
  if (!host || !window.requestAnimationFrame) return;
  var toggle = host.querySelector('[data-smoke-toggle]');

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORE = 'bo-haze';

  // off -> light -> smoky -> thick -> off
  var LEVELS = [
    { key: 'off',   alpha: 0,    density: 0   },
    { key: 'light', alpha: 0.85, density: 0.65 },
    { key: 'smoky', alpha: 1.8,  density: 1.15 },
    { key: 'thick', alpha: 3.1,  density: 1.9  }
  ];

  var defaultLevel = Math.max(0, Math.min(3, parseInt(host.dataset.smokeDefault || '2', 10)));
  var saved = null;
  try { saved = localStorage.getItem(STORE); } catch (e) {}
  var level = saved === null ? (reduced ? 0 : defaultLevel) : Math.max(0, Math.min(3, parseInt(saved, 10) || 0));
  var on = level > 0;

  var baseDensity = (parseFloat(host.dataset.smokeIntensity || '10') || 10) / 10;
  var reactivity = (parseFloat(host.dataset.smokeReact || '10') || 10) / 10;
  var settle = (parseFloat(host.dataset.smokeSettle || '5') || 5) / 10;

  var canvas = document.createElement('canvas');
  canvas.className = 'smoke-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  host.insertBefore(canvas, host.firstChild);
  var ctx = canvas.getContext('2d');

  var W = 0, H = 0, dpr = 1, parts = [], raf = null, last = 0, inView = true;
  var sprite = null, pal = null, fade = 0;
  var ptr = { x: -9999, y: -9999, px: -9999, py: -9999, vx: 0, vy: 0, active: false };

  function palette() {
    var bg = (getComputedStyle(document.body).backgroundColor.match(/\d+/g) || [30, 30, 30]).map(Number);
    var lum = bg[0] * 0.299 + bg[1] * 0.587 + bg[2] * 0.114;
    return lum > 140
      ? { r: 108, g: 98, b: 84, mode: 'source-over', alpha: 0.085 }
      : { r: 234, g: 228, b: 212, mode: 'lighter',    alpha: 0.042 };
  }

  /* one soft puff, drawn once and reused */
  function buildSprite(p) {
    var S = 128;
    var c = document.createElement('canvas');
    c.width = c.height = S;
    var g = c.getContext('2d');
    var rg = g.createRadialGradient(S / 2, S / 2, 0, S / 2, S / 2, S / 2);
    rg.addColorStop(0.0, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',1)');
    rg.addColorStop(0.45, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0.42)');
    rg.addColorStop(1.0, 'rgba(' + p.r + ',' + p.g + ',' + p.b + ',0)');
    g.fillStyle = rg;
    g.fillRect(0, 0, S, S);
    return c;
  }

  function lvl() { return LEVELS[level] || LEVELS[0]; }
  function target() {
    return Math.round(Math.min(220, (W * H) / 11000 * baseDensity * lvl().density));
  }

  function mk(seeded) {
    // Each puff has a slowly drifting "home". The pointer knocks it off that
    // home; a spring plus a curl term curls it back rather than snapping it.
    var max = 14 + Math.random() * 12;
    var x = Math.random() * W;
    var y = -60 + Math.random() * (H + 120);
    return {
      hx: x, hy: y,          // home
      x: x,  y: y,           // actual
      dx: 0, dy: 0,          // velocity
      vx: (Math.random() - 0.5) * 8,
      vy: -(4 + Math.random() * 10),
      r: 60 + Math.random() * 110,
      life: seeded ? Math.random() * max : 0,
      max: max,
      seed: Math.random() * 6.28,
      wob: 0.14 + Math.random() * 0.3,
      k: (0.30 + Math.random() * 0.34) * settle,   // spring stiffness
      curl: (Math.random() < 0.5 ? -1 : 1) * (0.22 + Math.random() * 0.34) * settle
    };
  }

  function resize() {
    var r = host.getBoundingClientRect();
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = Math.max(1, r.width); H = Math.max(1, r.height);
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    pal = palette();
    sprite = buildSprite(pal);
    var want = target();
    while (parts.length < want) parts.push(mk(true));
    parts.length = Math.min(parts.length, want);
  }

  function onMove(e) {
    var r = canvas.getBoundingClientRect();
    var x = e.clientX - r.left, y = e.clientY - r.top;
    if (ptr.px < -9000) { ptr.px = x; ptr.py = y; }
    ptr.x = x; ptr.y = y; ptr.active = true;
    if (on) start();
  }

  function step(now) {
    raf = requestAnimationFrame(step);
    if (!last) last = now;
    var dt = Math.min((now - last) / 1000, 0.05);
    last = now;

    // pointer velocity, smoothed
    ptr.vx = (ptr.x - ptr.px) / Math.max(dt, 0.001);
    ptr.vy = (ptr.y - ptr.py) / Math.max(dt, 0.001);
    ptr.px += (ptr.x - ptr.px) * 0.35;
    ptr.py += (ptr.y - ptr.py) * 0.35;

    fade += ((on ? 1 : 0) - fade) * Math.min(1, dt * 3.2);
    if (fade < 0.004 && !on) fade = 0;

    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = pal.mode;

    var want = on ? target() : 0;
    if (parts.length < want && inView) parts.push(mk(false));

    var R = 230, R2 = R * R;
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.life += dt;
      if (p.life >= p.max || p.hy < -p.r - 80) {
        if (on && inView && parts.length <= want) { parts[i] = mk(false); continue; }
        parts.splice(i, 1); continue;
      }

      // the home drifts on its own, so the haze never sits still
      p.hx += (p.vx + Math.sin(p.life * p.wob + p.seed) * 16) * dt;
      p.hy += p.vy * dt;

      // spring back toward home, with a perpendicular curl so it swirls
      var ex = p.hx - p.x, ey = p.hy - p.y;
      var ax = ex * p.k + (-ey * p.curl);
      var ay = ey * p.k + ( ex * p.curl);
      ax -= p.dx * 1.45;                 // overdamped: eases home, never bounces
      ay -= p.dy * 1.45;

      // the pointer shoves the haze around and drags it along
      if (ptr.active && reactivity > 0) {
        var dx = p.x - ptr.x, dy = p.y - ptr.y;
        var d2 = dx * dx + dy * dy;
        if (d2 < R2) {
          var d = Math.sqrt(d2) || 1;
          var f = (1 - d / R) * reactivity;
          ax += (dx / d) * f * 1150;
          ay += (dy / d) * f * 1150;
          ax += ptr.vx * f * 2.6;
          ay += ptr.vy * f * 2.6;
        }
      }

      p.dx += ax * dt;
      p.dy += ay * dt;
      p.x += p.dx * dt;
      p.y += p.dy * dt;

      if (p.hx < -p.r) { p.hx += W + 2 * p.r; p.x += W + 2 * p.r; }
      if (p.hx > W + p.r) { p.hx -= W + 2 * p.r; p.x -= W + 2 * p.r; }

      var t = p.life / p.max;
      var a = Math.sin(Math.min(t, 1) * Math.PI) * pal.alpha * lvl().alpha * fade;
      if (a <= 0.001) continue;
      ctx.globalAlpha = a;
      var s = p.r * (1 + t * 0.5);
      ctx.drawImage(sprite, p.x - s, p.y - s, s * 2, s * 2);
    }
    ctx.globalAlpha = 1;

    if (!on && fade === 0) {
      parts.length = 0;
      ctx.clearRect(0, 0, W, H);
      cancelAnimationFrame(raf); raf = null; last = 0;
    }
  }

  function start() { if (!raf) { last = 0; raf = requestAnimationFrame(step); } }

  function setLevel(n) {
    level = ((n % 4) + 4) % 4;
    on = level > 0;
    try { localStorage.setItem(STORE, String(level)); } catch (e) {}
    if (toggle) {
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.classList.toggle('on', on);
      toggle.dataset.level = LEVELS[level].key;
      var lbl = toggle.querySelector('[data-smoke-label]');
      var text = toggle.dataset[
        ['labelOff', 'labelLight', 'labelSmoky', 'labelThick'][level]
      ];
      if (lbl) lbl.textContent = text || LEVELS[level].key;
      toggle.setAttribute('aria-label', 'Haze: ' + (text || LEVELS[level].key) + '. Click to change.');
      var bars = toggle.querySelectorAll('.smoke-btn-icon i');
      for (var b = 0; b < bars.length; b++) {
        bars[b].classList.toggle('lit', b < level);
      }
    }
    if (on) { if (!parts.length) resize(); start(); }
  }

  if (toggle) toggle.addEventListener('click', function () { setLevel(level + 1); });
  host.addEventListener('pointermove', onMove, { passive: true });
  host.addEventListener('pointerleave', function () { ptr.active = false; }, { passive: true });

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(resize, 150); });
  document.addEventListener('visibilitychange', function () {
    inView = !document.hidden; if (inView && on) start();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting; if (inView && on) start();
    }, { threshold: 0 }).observe(host);
  }
  window.addEventListener('load', resize);

  resize();
  setLevel(level);
})();
